import React from "react"

import { NotificationManager } from "react-notifications"
import { gql, useMutation } from "urql"

import { LanguageIcon } from "@heroicons/react/24/solid"
import Tippy from "@tippyjs/react"

import classNames from "src/classNames"

type ToggleTranslationButtonProps = {
  studentSessionId: string
  liveTranslationEnabled: boolean
  languageLabel: string
}

const ToggleTranslationButton: React.FC<ToggleTranslationButtonProps> = ({
  studentSessionId,
  liveTranslationEnabled,
  languageLabel,
}) => {
  const [mutationResult, runMutation]: any[] = useMutation(
    toggleTranslationMutation
  )

  const handleClick = () => {
    runMutation({
      studentSessionId,
      enable: !liveTranslationEnabled,
    })
      .then(result => {
        const failures = result.data.studentSessionToggleTranslation.failures
        if (failures.length > 0) {
          NotificationManager.error(failures[0].message)
        }
      })
      .catch(() => NotificationManager.error("Something went wrong"))
  }

  const title = `${
    liveTranslationEnabled ? "Disable" : "Enable"
  } live translation (${languageLabel})`

  return (
    <Tippy content={title}>
      <button
        type="button"
        aria-label={title}
        aria-pressed={liveTranslationEnabled}
        title={title}
        className={classNames(
          "mr-4 inline-flex w-12 items-center justify-center rounded-sm border-none py-2 text-white outline-none transition duration-500",
          liveTranslationEnabled ? "bg-brand-600" : "bg-blue-700",
          mutationResult.fetching && "cursor-not-allowed bg-gray-400"
        )}
        disabled={mutationResult.fetching}
        onClick={handleClick}
      >
        <LanguageIcon className="h-4 w-4" />
      </button>
    </Tippy>
  )
}

const toggleTranslationMutation = gql`
  mutation TutorStudentSessionToggleTranslation(
    $studentSessionId: ID!
    $enable: Boolean!
  ) {
    studentSessionToggleTranslation(
      studentSessionId: $studentSessionId
      enable: $enable
    ) {
      failures {
        message
      }
    }
  }
`

export default ToggleTranslationButton
